import { graphql } from "@/lib/gql/__generated__/gql";

export const INVOICE_SYSTEM_SETTINGS_QUERY = graphql(/* GraphQL */ `
	query InvoiceSystemSettingsQuery($hotelID: ID!) {
		invoiceSystemSettings(hotelID: $hotelID) {
			hotelID
			id
			registrationCode
			registrationStatus
		}
	}
`);
